// extracted by mini-css-extract-plugin
export default {"taskSuggestion":"style_taskSuggestion__Ld4rH"};